export class ColorPalette {
    static fromJson(json) {
        const colors = json.colors.map((color) => {
            return color;
        });
        return new ColorPalette(colors);
    }
    constructor(colors) {
        this.colors = colors;
    }
    toJson() {
        const colors = this.colors.map((color) => {
            return color;
        });
        return {
            colors,
        };
    }
    getColors() {
        return this.colors;
    }
    setColors(colors) {
        this.colors = colors;
    }
    getCssColors() {
        return this.colors.map((color) => color);
    }
    sanitizeColors(defaultColors) {
        if (!defaultColors) {
            return;
        }
        if (!!this.colors && this.colors.length >= defaultColors.length) {
            this.colors = this.colors.slice(0, defaultColors.length);
        }
        else {
            this.colors = defaultColors.slice(0);
        }
    }
}
//# sourceMappingURL=color-palette.js.map